import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-modal';
import { Theme } from '../../config/theme';
import Button from '../Button';
import TextField from '../TextField';

const CLOSE_ICON = require('../MatchRequestModal/close.svg');

class CancelRequestModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateTextField = this.updateTextField.bind(this);

    this.state = {
      message: '',
      charCount: 0,
    };
  }

  handleClose() {
    this.setState({
      message: '',
      charCount: 0,
    });
    this.props.onClose();
  }

  handleSubmit(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    const trimmedMessage = this.state.message.trim();

    this.props.onSubmit(trimmedMessage);
    this.handleClose();
  }

  updateTextField(key, value) {
    const charCount = value.length;

    if (charCount <= 500) {
      this.setState({
        message: value,
        charCount,
      });
    }
  }

  render() {
    const { isOpen, dogName, recipientName } = this.props;

    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 9999,
      },
      content: {
        border: 0,
        padding: 0,
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: Theme.white,
        borderRadius: 5,
        width: 580,
        maxWidth: '95%',
      },
    };

    const recipientDisplayName = recipientName || 'the other member';
    const messagePlaceholder = recipientName
      ? `Hi ${recipientName}, I need to cancel because...`
      : 'I need to cancel because...';

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.handleClose}
        contentLabel="Cancel match request"
        style={modalStyle}
      >
        <div className={css(styles.modal)}>
          <button onClick={this.handleClose} className={css(styles.close)}>
            <img src={CLOSE_ICON} alt="Close" />
          </button>
          <h2 className={css(styles.title)}>Cancel your request</h2>
          <p className={css(styles.description)}>
            Let {recipientDisplayName} know why you’re cancelling your request to share {dogName}.
            They will see this message in their cancellation email.
          </p>
          <form onSubmit={this.handleSubmit}>
            <div className={css(styles.input_container)}>
              <TextField
                textArea
                name="message"
                value={this.state.message}
                handler={this.updateTextField}
                placeholder={messagePlaceholder}
                styles={styles.textAreaField}
              />
              <div className={css(styles.char_count)}>{this.state.charCount}/500 characters</div>
            </div>
            <div className={css(styles.buttons)}>
              <Button
                title="Go back"
                handler={this.handleClose}
                theme="grey"
                styles={styles.cancel_button}
              />
              <Button
                title="Confirm cancellation"
                handler={this.handleSubmit}
                theme="blue"
                styles={styles.submit_button}
              />
            </div>
          </form>
        </div>
      </Modal>
    );
  }
}

CancelRequestModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  dogName: PropTypes.string,
  recipientName: PropTypes.string,
};

CancelRequestModal.defaultProps = {
  dogName: 'this dog',
  recipientName: null,
};

const styles = StyleSheet.create({
  modal: {
    padding: 40,
    position: 'relative',
  },
  close: {
    position: 'absolute',
    top: 20,
    right: 20,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    outline: 'none',
  },
  title: {
    fontSize: 24,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.primary_color,
    marginBottom: 20,
    paddingRight: 30,
  },
  description: {
    fontSize: 16,
    lineHeight: 1.5,
    color: '#000e1f',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
  },
  input_container: {
    marginBottom: 30,
  },
  textAreaField: {
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    width: '100%',
    marginBottom: 10,

    ':not(.a) > *': {
      flexGrow: 1,
    },
  },
  char_count: {
    textAlign: 'right',
    fontSize: 14,
    color: '#999',
    marginTop: 5,
    fontFamily: Theme.font_family_primary,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 15,
  },
  cancel_button: {
    minWidth: 140,
  },
  submit_button: {
    minWidth: 200,
  },
});

export default CancelRequestModal;



// WEBPACK FOOTER //
// ./src/components/CancelRequestModal/index.js